/**
 * Words and small sums for the company Health tab (SF-5096).
 */
import type { CompanyUsage } from '../../../../components/usage/usageClient';

/**
 * Demo and Test companies are left out of the platform figures because their feedback is not
 * real use, so the tab shows only a note for them. Other companies that are not counted still
 * have real figures, which the tab shows under the note.
 */
export function hidesFigures(usage: CompanyUsage): boolean {
  return (
    !usage.counted && (usage.not_counted_reason === 'demo' || usage.not_counted_reason === 'test')
  );
}

/** The note shown when the company is not counted in platform usage; null when it is. */
export function notCountedNote(usage: CompanyUsage): string | null {
  if (usage.counted) return null;
  switch (usage.not_counted_reason) {
    case 'demo':
      return 'This company is not counted in platform usage (Demo)';
    case 'test':
      return 'This company is not counted in platform usage (Test)';
    case 'inactive':
      return 'This company is inactive, so it is not counted in platform usage. Its figures are shown below.';
    case 'internal':
      return 'ServeFirst Live: ServeFirst’s own company. It is never counted as a customer; the dashboard shows it on its own line.';
    default:
      return 'This company is not counted in platform usage.';
  }
}
